module.exports = __webpack_public_path__ + "img/icon_manejo_asistente_servicios.2077f28d.svg";